import type { NetworkType } from "@gearbox-protocol/sdk/onchain";
import { api } from "api";
import RouterErrorBox from "components/RouterErrorBox";
import type { NonIndexRouteObject } from "react-router-dom";
import OptimistExecutionRoute from "./OptimistExecutionRoute";
import OptimistRootRoute from "./OptimistRootRoute";
import OptimistRoute from "./OptimistRoute";
import OptimistTraceRoute from "./OptimistTraceRoute";

const INCLUDED_NETWORKS: NetworkType[] = [
  "Mainnet",
  "Plasma",
  "Etherlink",
  "Monad",
  "Somnia",
];

export const optimistRoute: NonIndexRouteObject = {
  element: <OptimistRoute />,
  errorElement: <RouterErrorBox />,
  children: [
    {
      index: true,
      loader: async () => {
        const resp = await api.listScheduledOptimists();
        return resp.filter(i => INCLUDED_NETWORKS.includes(i.network));
      },
      element: <OptimistRootRoute />,
    },
    {
      path: ":executionId",
      loader: async ({ params }) => {
        return api.optimistReport(params.executionId);
      },
      element: <OptimistExecutionRoute />,
    },
    {
      path: ":executionId/trace/:traceId",
      element: <OptimistTraceRoute />,
      loader: async ({ params }) => {
        return api.optimistTrace(params.executionId, params.traceId);
      },
    },
  ],
};
